import { queryOptions } from '@tanstack/react-query';
import { fetchSources } from '@/actions/sources';

const RESOURCE = 'sources' as const;

const sources = {
  all: () =>
    queryOptions({
      queryFn: () => fetchSources(),
      queryKey: [RESOURCE] as const,
    }),
};

export { RESOURCE as SOURCES_QUERY_KEY, sources };
